<template>
    <div class="blackBg animated bounceIn">
        <div class="cardTit">
            <span class="season ">{{ $store.state.seasonName }}</span>
            <span class="teamName">{{ teamName ? teamName : 'XXX' }}</span>
        </div>
        <div class="barDate cardBg">
            <div class="barTitCol">
                <span class="titLab"><0.8</span> <span class="titCol titColRed"></span>
                <span class="titLab">0.8~1.3</span> <span class="titCol titColYellow"></span>
                <span class="titLab">1.3~1.5</span> <span class="titCol  titCoGreen"></span>
                <span class="titLab">>1.5</span> <span class="titCol titColRed"></span>
            </div>
            <div class="barBox">
                <p class="barTit PingFang">{{ $route.params.name }}</p>
                <div id="gpsBar" style="height: 100%;width: 100%"></div>
            </div>
            <p class="projection"><img src="../assets/img/numBg.svg" alt=""></p>
        </div>
    </div>
</template>

<script>
export default {
    name: "AC_reportDetail",
    data() {
        return {
            userId: this.$route.params.id,//球员id
            teamName: this.$store.state.teamName.split('_')[0],//梯队名称
            ACItem: [],
            ACPlayerWeeks: [],//周数组
            ACData: [],//ac总数据
            scrollDomWidth: 0,//滚动宽度
            scrollTime: 0,//滚动时间
            time: null,//定时器
        }
    },
    watch: {
        userId: {
            handler(val, old) {
                this.info();
            },
            deep: true
        }
    },
    computed: {
        teamId() {
            return this.$store.state.teamId;
        }
    },
    mounted() {
        this.info();
    },
    methods: {
        info() {
            this.getFilter();
        },
        //  获取gps 筛选项
        getFilter() {
            let data = {
                teamId: this.teamId
            }
            this.$server.getGpsFilter(data).then(res => {
                if (res.code === 200) {
                    this.ACItem = [];
                    if (res.data && res.data.length) {
                        let arr = [];
                        res.data.map(item => {
                            if (item.ac) {
                                // console.log(item.slug)
                                arr.push({
                                    ...item,
                                    allData: [],
                                })
                            }

                        })
                        this.ACItem = arr;
                        this.getAC()
                    }
                }
            })
        },
        getAC() {
            let data = {
                teamId: this.teamId,
                year: new Date().getFullYear(),
                playerId: this.userId,
            }
            this.$server.getACReport(data).then((res) => {
                if (res.code == 200) {
                    let GPSData = res.data[0];
                    this.ACPlayerWeeks = [];

                    if (GPSData != null && GPSData != undefined && GPSData.length > 0) {
                        GPSData.forEach((item) => {
                            this.ACPlayerWeeks.push('W' + item.weekIndex)
                            this.ACItem.forEach(gps => {
                                if (item.data && item.data.length) {
                                    const currentGps = item.data.find(dataValue => dataValue.slug === gps.slug)
                                    if (currentGps && currentGps.value) {
                                        gps.allData.push({
                                            value: Number(currentGps.ac).toFixed(gps.decimal),
                                            timeFormat: gps.timeFormat,
                                            name: gps.displayName
                                        })
                                    }
                                }else {
                                    gps.allData.push({
                                        value: '',
                                        timeFormat: 0,
                                        name: gps.displayName
                                    })
                                }
                            })
                        })
                    }

                    this.ACBar(this.ACItem);
                    this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                    this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是" + this.$route.params.name + '的ac数据'), true, false)
                }
            })
        },
        ACBar(data) {
            let dom = document.getElementById('gpsBar');
            let myChart = this.$echarts.init(dom);
            let lookDom = document.querySelector('.barDate')
            //柱状图显示宽度
            if (parseInt(lookDom.offsetWidth) > (200 * this.ACPlayerWeeks.length)) {
                dom.style.width = (parseInt(lookDom.offsetWidth)) + 'px';
            } else {
                dom.style.width = (200 * this.ACPlayerWeeks.length) + "px";
            }
            myChart.resize();
            let option = null;

            let series = [];
            //遍历所得到的数据，分别创建不同的bar->series
            this.ACItem.forEach((itemChild) => {
                series.push(
                    {
                        type: 'bar',

                        itemStyle: {
                            normal: {
                                barBorderRadius: [3, 3, 0, 0],
                                color: (params) => {
                                    let index_color = params.value;
                                    if (index_color >= 0 && index_color < 0.8) {
                                        return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 1,
                                            color: '#EC3C3C'
                                        },
                                            {
                                                offset: 0,
                                                color: '#EB4511'
                                            }]);
                                    } else if (index_color >= 0.8 && index_color < 1.3) {
                                        return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 1,
                                            color: '#70FABB'
                                        },
                                            {
                                                offset: 0,
                                                color: '#E1E85B'
                                            }])
                                    } else if (index_color >= 1.3 && index_color < 1.5) {
                                        return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 1,
                                            color: '#FAE586'
                                        },
                                            {
                                                offset: 0,
                                                color: '#EEBC31'
                                            }])
                                    } else if (index_color > 1.5) {
                                        return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 1,
                                            color: '#F71735'
                                        },
                                            {
                                                offset: 0,
                                                color: '#DB3445'
                                            }]);
                                    } else {
                                        return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 1,
                                            color: '#F71735'
                                        },
                                            {
                                                offset: 0,
                                                color: '#DB3445'
                                            }]);
                                    }
                                }
                            }
                        },
                        data: itemChild.allData,
                        barWidth: 15,
                        label: {
                            show: true,
                            position: 'top',
                            rotate: '90',
                            align: 'left',
                            verticalAlign: 'middle',
                            distance: '5',
                            formatter: function (params) {
                                if (params.value >= 0) {
                                    return ['{b|' + params.value + '}', '{a|' + itemChild.name + '}'].join('  ');
                                } else {
                                    return '';
                                }
                            },
                            rich: {
                                a: {
                                    color: 'rgba(255, 255, 255, .5)',
                                    fontSize: '14',
                                },
                                b: {
                                    color: 'rgba(255, 255, 255, .8)',
                                    fontSize: '14',
                                    fontWeight: '600'
                                }
                            },
                        },
                        markLine: {
                            symbol: ['none', 'none'],//去掉箭头
                            itemStyle: {
                                normal: {
                                    lineStyle: {
                                        type: 'solid',
                                        color: '#F34E4E'
                                    }
                                },
                                label: {
                                    fontSize: 16,
                                    show: true,
                                    position: 'middle'
                                }
                            },
                            data: [
                                {
                                    yAxis: 0.8,
                                    lineStyle: {
                                        type: 'solid',
                                        color: '#F34E4E'
                                    }
                                },
                                {
                                    yAxis: 1.3,
                                    lineStyle: {
                                        type: 'solid',
                                        color: '#F3C74E'
                                    }
                                },
                                {
                                    yAxis: 1.5,
                                    lineStyle: {
                                        type: 'solid',
                                        color: '#F34E4E'
                                    }
                                },
                            ]
                        },
                    }
                )
            })

            option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top: '35%',
                    left: '0',
                    right: '5%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.ACPlayerWeeks,
                        axisLabel: {
                            color: '#fff',
                            fontSize: '20',
                            margin: 20,
                        },
                        axisLine: {       // 坐标轴 轴线
                            show: true,  // 是否显示
                            // ------   线 ---------
                            lineStyle: {
                                color: 'rgba(255, 255, 255, .5)',
                                width: 1,
                                type: 'solid',
                                opacity: '0.3',
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#666',
                                opacity: '0.3',
                                type: 'dotted'
                            },
                            show: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        max: function (value) {
                            return value.max + 2;
                        },
                        axisLabel: {
                            color: '#fff',
                            fontSize: 14,
                            margin: 15,
                        },
                        axisLine: {       // 坐标轴 轴线
                            show: true,  // 是否显示
                            // ------   线 ---------
                            lineStyle: {
                                color: 'rgba(255, 255, 255, .5)',
                                width: 1,
                                type: 'solid',
                                opacity: '0.3',
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#666',
                                opacity: '0.3',
                                type: 'dotted',
                                fontSize: 16,
                            },
                            show: true
                        }
                    }
                ],
                series: series
            };
            myChart.setOption(option, true);
            if (this.ACPlayerWeeks.length) {
                let timeScroll = null
                timeScroll = setTimeout(() => {
                    const lookEl = document.querySelector('.barDate')
                    const el = document.querySelector('#gpsBar');
                    this.scrollDomWidth = el.offsetWidth - lookEl.offsetWidth + 100;
                    this.scrollTime = 3 + Math.floor(this.scrollDomWidth / 500) * 5
                    if (this.scrollDomWidth > 100) {
                        let t = setTimeout(() => {
                            this.scroll();
                            clearTimeout(t);
                            clearInterval(this.time);
                            this.time = setInterval(this.scroll, (this.scrollTime * 1000) + 500);
                        })
                    }
                    clearInterval(timeScroll)
                })
            }


        },
        //滚动
        scroll() {
            const el = document.querySelector('#gpsBar');
            let style = el ? el.getAttribute('style') : '';
            let styleStr = '';
            if (style && style == 'margin-left:' + -(this.scrollDomWidth) + 'px;transition: all linear ' + this.scrollTime + 's') {
                styleStr = 'margin-left:0px;transition: all ' + this.scrollTime + 's'
            } else {
                styleStr = 'margin-left:' + -(this.scrollDomWidth) + 'px;transition: all linear ' + this.scrollTime + 's'
            }
            el ? el.setAttribute('style', styleStr) : '';
        }
    },
    beforeDestroy() {
        clearInterval(this.time)
        this.time = null;
    }
}
</script>

<style scoped lang="less">
.cardTit {
    background-image: url("../assets/img/updateImg/head_2.png");
    position: relative;
    font-size: 30px;

    .season {
        font-family: PingFangMedium;
        color: #fff;
        display: inline-block;
        position: absolute;
        line-height: 130px;
        left: 2vw;
    }
}

.barDate {
    width: 100%;
    padding: 2vw 1vw;
    box-sizing: border-box;
    height: calc(100% - 8vw);
    position: relative;

    .barBox {
        margin-right: 1vw;
        margin-left: 1vw;
        width: calc(100% - 2vw);
        height: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        position: relative;
    }

    .barTitCol {
        padding-bottom: 1vw;
        margin-right: 1vw;
        position: absolute;
        right: 3vw;
        top: 3.5vw;
        font-size: 22px;

        span {
            float: right;
        }

        .titCol {
            width: 20px;
            height: 20px;
        }

        .titColRed {
            background: #F34E4E;
        }

        .titCoGreen {
            background: #76C072;
        }

        .titColYellow {
            background: #F3C74E;
        }

        .titLab {
            font-family: PingFang;
            color: #fff;
            padding-left: .5vw;
            padding-right: 1.5vw;
            margin-top: -8px;
        }
    }

    .barTit {
        position: absolute;
        color: #71ABFB;
        font-size: 36px;
        /*top: -.5vw;*/
    }
}

.projection img {
    width: 100%;
}
</style>
